import { Pencil } from 'lucide-react';
import { Button, Dialog, formatDateTime } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { EntryList, type Entry } from '../EntryList.tsx';
import type { Customer } from './customers.ts';
import styles from './Customers.module.css';

export type CustomerRecordProps = {
  customer: Customer;
  editable: boolean;
  onEdit: () => void;
  onClose: () => void;
};

export const CustomerRecord = ({ customer, editable, onEdit, onClose }: CustomerRecordProps) => {
  const { t, i18n } = useTranslation();
  const entries: readonly Entry[] = [
    { key: 'phone', value: customer.phone, ltr: true },
    { key: 'secondPhone', value: customer.secondPhone, ltr: true },
    { key: 'email', value: customer.email, ltr: true },
    { key: 'address', value: customer.address },
    { key: 'governorate', value: customer.governorate },
    { key: 'city', value: customer.city },
    { key: 'postalCode', value: customer.postalCode },
    { key: 'notes', value: customer.notes },
    { key: 'createdAt', value: formatDateTime(customer.createdAt, i18n.language) },
  ];

  return (
    <Dialog
      open
      variant="side"
      title={customer.name}
      closeLabel={t('common.close')}
      onClose={onClose}
      footer={
        editable ? (
          <Button icon={<Pencil size={20} aria-hidden="true" />} onClick={onEdit}>
            {t('customers.edit')}
          </Button>
        ) : undefined
      }
    >
      {customer.piiVisible ? null : (
        <p className={styles['notice']} role="status">
          {t('customers.masked')}
        </p>
      )}
      <EntryList entries={entries} labelOf={(key) => t(`customers.${key}`)} />
    </Dialog>
  );
};
